export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 21c4.96 0 9-4.04 9-9s-4.04-9-9-9-9 4.04-9 9 4.04 9 9 9zm0-16c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7zm0 12a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM11 7h2v6.5h-2V7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};